import { useState, useEffect } from "react";
import { SolicitudesTraspaso } from "../cambios-contractuales/cambio-de-instalacion/solicitudes-pendientes/solicitudesTraspaso";
import { HistorialSolicitudes } from "../cambios-contractuales/historial-solicitudes/historialSolicitudes";
import { SolicitudesEnCurso } from "../cambios-contractuales/solicitudes-en-curso/SolicitudesEnCurso";
import { AjustesDeDias } from "../cambios-contractuales/ajustes-de-dias/ajustesDias";
import { EnviarSAP } from "../cambios-contractuales/por-enviar-a-sap/enviarSap";
import { PageNotFound } from "../pages/errores/PageNotFound/404page";
import { Routes, Route, Navigate } from "react-router-dom";
import { Index } from "../cambios-contractuales";
import { getUno } from "../api/apis";
import PropTypes from 'prop-types';

export const RutasContractual = (props) => {
  const { modulo } = props;
  const [listadoPorAprobar, setListadoPorAprobar] = useState([]);

  const getSolicitudesCambio = async () => {
    const resp = await getUno('getsolicitudescambio', null, null);

    if (resp.data.data.length > 0) {
      setListadoPorAprobar(resp.data.data);
    }
  }
  useEffect(() => {
    getSolicitudesCambio();
  }, []);

  return (
    <div>
      <Routes>
        {modulo === '2' &&
          <>
            <Route path="/" element={["4"].includes(localStorage.getItem("id_perfil")) ? <Index /> : <SolicitudesEnCurso />} />
            <Route path="/solicitudes-traspaso" element={<SolicitudesTraspaso listado={listadoPorAprobar} />} />
            <Route path="/historial-solicitudes" element={<HistorialSolicitudes />} />
            {["3"].includes(localStorage.getItem("id_perfil")) && (
              <>
                <Route path="/envio-a-sap" element={<EnviarSAP />} />
                <Route path="/ajustes-de-dias" element={<AjustesDeDias />} />
              </>
            )}
          </>
        }
        {modulo === '3' &&
          <>
            <Route path="/desvinculacion-colaborador" element={<Index modulo={modulo} />} />
            <Route path="*" element={<Navigate to="/desvinculacion-colaborador" replace />} />
          </>
        }
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
  );
};

RutasContractual.propTypes = {
  modulo: PropTypes.string,
};
